/* eslint-disable require-jsdoc */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/** navbar */
/** opens navbar */
function openNav() {
	document.getElementById('mySidenav').style.width = '250px';
}
/** closes navbar */
function closeNav() {
    document.getElementById('mySidenav').style.width = '0';
}

